import {MatrixClient} from 'matrix-js-sdk';

export const checkIfUserIsRoomMember = async (
  matrixClient: MatrixClient,
  roomId: string,
  matrixUserId: string
): Promise<boolean> => {
  try {
    const members = await matrixClient.members(roomId);
    const isMember = members?.chunk.some(
      (member) =>
        member.state_key === matrixUserId &&
        member.content.membership === 'join'
    );

    return isMember;
  } catch (error) {
    console.log('Error while checking if user is room member: ', error);
    return false;
  }
};
